import basePath from "base_path";
import requestor from "requestor";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import ActionTypes, {UsergroupActionTypes} from "../constants/action_types";
import {Usergroup} from "common/types/usergroup";

export type CreateUsergroupAction = {
  type: UsergroupActionTypes["USERGROUP_CREATE"]["SUCCESS"];
  payload: Usergroup;
};

export default createReduxPromiseAction(
  ActionTypes.USERGROUP_CREATE,
  (organisationId: number, name: string) =>
    requestor
      .post(
        `${basePath}/organisation/${organisationId}/usergroup`,
        {name},
        {withCredentials: true},
      )
      .then(({data: {id}}) => ({id, name})),
);
